import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilter1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFilter1"><Path d="M3 3V8.31066L9 14.3107V21.935L15 20.6016V14.3107L21 8.31066V3H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFilter1;
